<template>
  <div class="wrapper">
    <el-header>
      <h3 class="title">
        <div class="block">
          <span>Web接入</span>
        </div>
      </h3>
    </el-header>
    <el-row type="flex" justify="end">
      <el-button type="info" icon="el-icon-plus" style="margin-bottom: 10px;" size="small" @click="createWebConfig()">添加</el-button>
    </el-row>
    <el-scrollbar class="scrollbar-wrap">
      <el-table :data="tableData" size="small" style="width: 100%" @row-dblclick="updateConfig">
        <el-table-column label="网站名称" prop="name" align="center"></el-table-column>
        <el-table-column label="路由策略" prop="routeStrategyName" align="center"></el-table-column>
        <el-table-column label="最后更新时间" prop="updateTime" align="center"></el-table-column>
        <el-table-column fixed="right" label="操作" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" content="修改" placement="bottom">
              <el-button type="text" size="small" @click="updateConfig(scope.row)">
                <svg class="icon icon-bianji" aria-hidden="true">
                  <use xlink:href="#icontable-bianji" />
                </svg>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="light" content="接入代码" placement="bottom">
              <el-button type="text" size="small" @click="showAccessCode(scope.row)">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconjierudaima" />
                </svg>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="light" content="删除" placement="bottom">
              <el-button type="text" @click="deleteConfig(scope.row)" size="small">
                <svg class="icon icon-delete" aria-hidden="true">
                  <use xlink:href="#icontable-delete" />
                </svg>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!-- 底部分页栏 -->
      <el-row style="float:right;">
        <el-pagination background layout="total, prev, pager, next, jumper" :page-size.sync="pageSize" :current-page.sync="pageNum" :total="total" @current-change="handleCurrentChange"></el-pagination>
      </el-row>
    </el-scrollbar>
  </div>
</template>

<script>
import { deleteConfigById, getWebConfigsPaged } from '@/api/channel/web.js'
export default {
  name: 'WebList',
  data() {
    return {
      // 表格数据
      tableData: [],
      // 分页参数
      pageNum: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted() {
    this.handleCurrentChange(1)
  },
  computed: {
  },
  methods: {

    // 查询web端配置列表
    getWebConfigList() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      getWebConfigsPaged(params).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).catch(err => {
        this.$message.error(err)
      })
    },
    // 创建web配置
    createWebConfig() {
      this.$parent.changeView('addWeb')
    },
    // 更新web配置
    updateConfig(row) {
      this.$parent.currentChannelInfoId = row.id
      this.$parent.changeView('addWeb')
    },
    // 转到接入代码页面
    showAccessCode(row) {
      this.$parent.accessScriptSrc = window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_BP_SERVICE') + '/res/download/access/webChatEntranceScript?accessKey=' + row.webAccessKey
      this.$parent.changeView('accessCode')
    },
    deleteConfig(row) {
      this.$confirm('删除后将无法撤销，您是否要删除该内容？', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        showClose: false,
        type: 'warning'
      }).then(() => {
        deleteConfigById({ id: row.id }).then(res => {
          this.handleCurrentChange(1)
          this.$message.success('删除成功')
        }).catch(err => {
          this.$message.error(err)
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    // 分页栏点击事件
    handleCurrentChange(val) {
      this.pageNum = val
      this.getWebConfigList()
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
}
.scrollbar-wrap {
  height: calc(100% - 60px - 42px);
}
.el-header {
  height: auto !important;
  margin-bottom: 10px;
  padding: 0;
  .title {
    margin-bottom: 20px;
  }
}
.el-form {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>
